<button
    [ngClass]="buttonAssignmentBooleanValue()"
    (click)="changeBooleanValue()"
    [disabled]="!show"
>
  {{ this.buttonText }}
  <span *ngIf="spinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>
